export const reservationDrawer = {
  title: "Dettagli prenotazione",
  openFullPage: "Apri a pagina intera",
  close: "Chiudi",
};
